import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

import { globalSlice } from './reducers';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, globalSlice.reducer);

const store = configureStore({
  reducer: {
    global: persistedReducer,
  },
});

const persistor = persistStore(store);

export { store, persistor };